import React, { useEffect, useState } from "react";
import GroupOrder from "../../assets/GroupOrder.png";
import calender from "../../assets/calender.png";
import profile from "../../assets/profile.png";
import address from "../../assets/orders/address.png";
import desc from "../../assets/orders/desc.png";
import upload from "../../assets/orders/upload.png";
import statusIcon from "../../assets/orders/status.png";
import check from "../../assets/orders/check.png";
import guatantee from "../../assets/orders/guatantee.png";
import stepsCompleted from "../../assets/orders/stepsCompleted.png";
import { Link, useNavigate } from "react-router-dom";
import { CheckCircleFilled, DownOutlined, UpOutlined } from "@ant-design/icons";
import { Carousel, Collapse, Input, message, Modal, Rate } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrderById } from "../../redux/ShowOrderIdSlice";
import { useTranslation } from "react-i18next";
import { submitFeedback } from "../../redux/rateOrderSlice";
import ReactStars from "react-stars";
const { TextArea } = Input;

const UnderGuaranteeModal = ({ idOrder }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [isModalView, setIsModalView] = useState(false);

  const showModalView = () => {
    setIsModalView(true);
  };
  const handleOkView = () => {
    setIsModalView(false);
  };
  const handleCancelView = () => {
    setIsModalView(false);
  };

  const [collapsed, setCollapsed] = useState(false);
  let [open, setOpen] = useState(false);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
    {
      collapsed ? <DownOutlined /> : <UpOutlined />;
    }
  };
  const customExpandIcon = ({ isActive }) =>
    isActive ? (
      <UpOutlined className="plus-icon mt-4" />
    ) : (
      <DownOutlined className="plus-icon mt-4" />
    );

  const dispatch = useDispatch();
  const { order } = useSelector((state) => state.order);

  useEffect(() => {
    dispatch(fetchOrderById(idOrder));
  }, [dispatch]);

  const { feedbackStatus, status, error } = useSelector(
    (state) => state.rateOrder
  );

  const [rate, setRate] = useState(0);
  const handleRatingChange = (newRating) => {
    setRate(newRating);
  };
  const [rateComment, setRateComment] = useState("");

  const items = [
    {
      key: "1",
      label: t("Order Details"),
      children: (
        <div>
          <div className="px-5">
            <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
              <div className="flex items-center mt-3 ">
                <img src={calender} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#283D63] font-medium">
                  {order?.date} | {order?.time}
                </p>
              </div>
              <div className="flex items-center mt-3 ">
                <img src={address} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#283D63] font-medium">{order?.address}</p>
              </div>
            </div>

            <div className="flex items-start mt-5 ">
              <img src={desc} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
              <p className="text-[#283D63] font-medium">{order?.description}</p>
            </div>

            <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
              <div className="flex items-center mt-3 ">
                <img
                  src={upload}
                  className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                {order?.uploaded_images?.length > 0 ? (
                  <>
                    <button
                      onClick={showModalView}
                      className="text-[#6682B6] underline font-medium"
                    >
                      {t("View Uploaded Images")}
                    </button>
                    <Modal
                      title={t("Uploaded Images")}
                      className="orderModal orderModalPricing w_small_modal"
                      open={isModalView}
                      onOk={handleOkView}
                      onCancel={handleCancelView}
                      footer={null}
                    >
                      <Carousel
                        arrows
                        infinite={false}
                        className="custome_carousel_images"
                      >
                        {order?.uploaded_images?.map((img, index) => (
                          <div key={index}>
                            <img
                              src={`https://service.samoolah.com/${img}`}
                              alt={`Uploaded image ${index + 1}`}
                              className="w-[120px] mx-auto my-5"
                            />
                          </div>
                        ))}
                      </Carousel>
                    </Modal>
                  </>
                ) : (
                  <p className="text-[#283D63] font-medium">
                    {t("No Uploaded Images")}
                  </p>
                )}
              </div>
              <div className="flex items-center mt-3 ">
                <img src={statusIcon} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#737E91] font-medium">{t("Status")}</p>
                <p className="text-[#283D63] font-medium ml-2">{t("Completed")}</p>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ];

  const onChange = (key) => {
    console.log(key);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenReturnOrder, setIsModalOpenReturnOrder] = useState(false);

  const handleSubmit = async () => {
    if (!rate) {
      message.error(t("Please provide a rating."));
      return;
    }

    const feedbackData = {
      order_id: idOrder,
      rate,
      rate_comment: rateComment,
    };

    try {
      await dispatch(submitFeedback(feedbackData))
        .unwrap()
        .then(() => {
          setIsModalOpen(false);
          message.success(t("Thank you for your feedback!"));
        });
    } catch (error) {
      console.error(t("Error submitting feedback:"), error);
      message.error(t("Failed to submit feedback. Please try again."));
    } finally {
      setLoading(false);
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showModalReturnOrder = () => {
    setIsModalOpenReturnOrder(true);
  };

  const handleOkReturnOrder = () => {
    setIsModalOpenReturnOrder(false);
  };

  const handleCancelReturnOrder = () => {
    setIsModalOpenReturnOrder(false);
  };

  const formatDateTime = (dateString) => {
    const dateObject = new Date(dateString);
    const day = String(dateObject.getDate()).padStart(2, "0");
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const year = dateObject.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;

    const hours = String(dateObject.getHours()).padStart(2, "0");
    const minutes = String(dateObject.getMinutes()).padStart(2, "0");

    const formattedTime = `${hours}:${minutes}`;

    return { formattedDate, formattedTime };
  };

  const { formattedDate, formattedTime } = formatDateTime(order?.updated_at);

  return (
    <div>
      <div className="mx-auto text-center">
        <img src={check} className="w-[50px] mx-auto my-5" />
        <p className="text-[#525D71] font-semibold">{t("Order Complete")}</p>
      </div>
      <div className="my-5 mx-auto">
        <img
          src={`https://service.samoolah.com/${order?.category?.icon}`}
          className="w-[120px] mx-auto bg-[#FCFBFA] rounded-2xl p-3"
        />
      </div>
      <div className="text-center">
        <p className="text-[#737E91] font-semibold text-xl">
        {t("Order number")}
          <span className="text-[#283D63] font-semibold">#{idOrder}</span>
        </p>
        <p className="text-[#A6ADB9] mt-2">
        {t("Order created on")} {formattedDate} <br /> {formattedTime}
        </p>
      </div>

      <button className="text-[#FE9B71] rounded-full text-lg font-semibold border-2 border-[#FE9B71] px-10 py-2 mt-5 mb-5 flex mx-auto">
         {t("View receipt")}
      </button>

      {/* <div>
        <button
          onClick={showModalReturnOrder}
          className="bg-[#FE9B71] text-white rounded-full px-10 py-2 text-lg mx-auto flex"
        >
          Return Order
        </button>
        <Modal
          title=""
          className="orderModal orderModalPricing w_small_modal"
          open={isModalOpenReturnOrder}
          onOk={handleOkReturnOrder}
          onCancel={handleCancelReturnOrder}
          footer={null}
        >
          <div className="mt-6">
            <p className="text-[#14294F] text-center font-bold text-xl">
              Are you sure you’d like to return <br />
              this order?
            </p>
            <p className="text-[#A6ADB9] text-center text-lg my-4">
              You’ll be receiving emails with all the details. Please note that
              delivery fees will be deducted from the total refund amount
            </p>
            <div className="flex items-center justify-center my-4 mt-6 max-lg:mx-5">
              <button className="bg-[#FE9B71] text-white rounded-full px-14 max-lg:px-10 h-10 text-lg">
                Cancel
              </button>
              <button className="text-[#FE9B71] rounded-full text-lg font-semibold border-2 border-[#FE9B71] px-14 max-lg:px-10 h-10 ml-4">
                Return
              </button>
            </div>
          </div>
        </Modal>
      </div> */}

      <div className="flex justify-center text-center my-4">
        <div className="w-1/2">
          <img src={guatantee} className="w-[60px] mx-auto my-3" />
          <p className="text-xl text-[#525D71] font-semibold">
            {t("This service is under guarantee")}
          </p>
          <p className="text-[#A6ADB9]">
             {t("From any issues or faults that might reoccur for 30 days from date of receipt issuance")}
          </p>
        </div>
      </div>

      <div className="bg-[#FCFBFA] rounded-2xl my-5 px-7 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            {order?.agent?.image == null ? (
              <img src={profile} className={`w-[48px] ${language == "en" ? "mr-3" : "ml-3"}`} />
            ) : (
              <img
                src={`https://service.samoolah.com${order?.agent?.image}`}
                className={`w-[48px] ${language == "en" ? "mr-3" : "ml-3"} rounded-full`}
                onError={(e) => (e.target.src = profile)}
              />
            )}
            <p className="text-[#525D71] font-medium text-lg">
              {order?.agent?.name} {order?.agent?.last_name} {t("handled your service request")}
              
            </p>
          </div>
        </div>
      </div>

      <Collapse
        defaultActiveKey={["1"]}
        inlineCollapsed={collapsed}
        items={items}
        expandIcon={customExpandIcon}
        expandIconPosition="right"
        bordered={false}
        className="bg-white custom_collapse"
      />

      <div className="mt-3">
        {order?.rate == null ? (
          <>
            <h3 className="text-[#14294F] text-xl font-semibold">
               {t("Rate Service Provided")}
            </h3>
            <p className="text-[#42567B] mt-4 text-center font-semibold">
               {t("How satisfied are you with the service provided?")}
            </p>
            <>
              <ReactStars
                count={5}
                onChange={handleRatingChange}
                value={rate}
                size={30}
                color1={"#dcdcdc"}
                color2={"#ffd700"}
                half={true}
                className="mx-auto flex justify-center mt-0 relative z-10"
              />

              <p className="text-[#42567B] mt-1 text-center">
                 {t("Do you have any reviews or suggestions that you’d like to share?")}
              </p>

              <div className="lg:mx-10">
                <TextArea
                  placeholder={t("Type in here your reviewsuggestions")}
                  allowClear
                  onChange={(e) => setRateComment(e.target.value)}
                  className="w-full my-4 border-0 h-[100px] rounded-3xl"
                />
              </div>

              <div>
                <button
                  type="button"
                  onClick={handleSubmit}
                  disabled={feedbackStatus === "loading"}
                  className={`bg-[#FE9B71] text-white rounded-full px-14 py-3 text-lg mx-auto flex ${
                    feedbackStatus === "loading" &&
                    "opacity-50 cursor-not-allowed"
                  }`}
                >
                  {feedbackStatus === "loading" ? t("Submitting...") : t("Submit")}
                </button>
                <Modal
                  title=""
                  className="orderModal orderModalPricing w_small_modal"
                  open={isModalOpen}
                  onOk={handleOk}
                  onCancel={handleCancel}
                  footer={null}
                >
                  <div className="mt-6">
                    <p className="text-[#14294F] text-center font-bold text-xl">
                      {t("Your feed back has been submitted")} <br /> {t("Successfully")}
                    </p>
                    <p className="text-[#A6ADB9] text-center text-lg my-4">
                      {t("Thanks for giving the time to rate our services.")}
                    </p>
                    <button
                      onClick={handleCancel}
                      className="bg-[#FE9B71] text-white rounded-full px-10 py-2 text-lg mx-auto flex my-4 mt-8"
                    >
                       {t("Continue")}
                    </button>
                  </div>
                </Modal>
              </div>
            </>
          </>
        ) : (
          <>
            <h3 className="text-[#14294F] text-xl font-semibold">{t("My Rate")}</h3>
            <p className="text-[#42567B] my-4 text-center font-semibold">
               {t("You gave a total of")}
            </p>
            <div className="flex mx-auto justify-center">
              <Rate disabled defaultValue={order?.rate} />
            </div>

            <p className="text-[#42567B] mt-4 text-center font-semibold">
               {t("Your review")}
            </p>
            <p className="bg-[#F9FBFC] text-[#A3B9DD] p-4 rounded-xl mt-4">
              {order?.rate_comment}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default UnderGuaranteeModal;
